import LicensePlateChangeNoticeViewModel from "viewModels/notice/licensePlateChange/licensePlateChangeNoticeViewModel";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import { registerWidget } from "../widget";
import InitializationWithOutagesService from "services/initialization/initializationWithOutagesService";

const LicensePlateChangeNoticeWidgetIdentifier = "edaz-notice";

registerWidget({
  component: makeWidgetFor(
    LicensePlateChangeNoticeWidgetIdentifier,
    [LicensePlateChangeNoticeViewModel],
    InitializationWithOutagesService
  ),
  configuration: {
    tagname: LicensePlateChangeNoticeWidgetIdentifier,
  },
});
